import React from "react";
import { Link } from "react-router-dom";
import { INFO, openEmail, useSiteSettings } from "../../core/site";
import { useLocales } from "../../core/i18n";
import { CONTAINER } from "./layout";

const LINK =
	"font-mono text-pp-label uppercase tracking-pp-label text-pp-muted hover:text-pp-ink transition-colors duration-150 inline-flex items-center min-h-11 sm:min-h-8";

/** Who this is: the name and the current company (the first venture listed). */
const SignOff = () => {
	const { t } = useLocales();
	const company = INFO.modules.startups.ventures[0];
	return (
		<div>
			<Link to="/" className="font-sligoil font-bold text-pp-ink text-pp-title-md">
				{INFO.main.name}
			</Link>
			<p className="text-pp-muted text-sm mt-2">
				{t("footer.role")}{" "}
				<a
					href={`https://${company.website}`}
					target="_blank"
					rel="noopener noreferrer"
					className="text-pp-ink underline decoration-pp-rule underline-offset-4 hover:decoration-pp-ink"
				>
					{company.name}
				</a>
				<span aria-hidden="true"> · </span>
				{t("footer.place")}
			</p>
		</div>
	);
};

/**
 * The site footer, a sign-off rather than a sitemap: who this is, where else
 * to find her (Malt only while open to work), the email opener, the year and
 * the Creative Forge link. The nav already lists the pages.
 */
const Footer = () => {
	const { t } = useLocales();
	const { openToWork } = useSiteSettings();
	const links = [
		{ href: INFO.socials.github.link, label: t("footer.github") },
		{ href: INFO.socials.linkedin.link, label: t("footer.linkedin") },
		{ href: INFO.socials.instagram.link, label: t("footer.instagram") },
		...(openToWork ? [{ href: INFO.socials.malt.link, label: t("footer.malt") }] : []),
	];

	return (
		<footer className="bg-pp-bg border-t border-pp-rule mt-auto">
			<div className={`${CONTAINER} pt-12 sm:pt-14 pb-8`}>
				<div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
					<SignOff />
					<nav aria-label={t("footer.elsewhere")}>
						<ul className="grid grid-cols-2 gap-x-7 sm:flex sm:flex-wrap">
							{links.map(({ href, label }) => (
								<li key={href}>
									<a
										href={href}
										target="_blank"
										rel="noopener noreferrer"
										className={LINK}
									>
										{label}
									</a>
								</li>
							))}
							<li>
								<button type="button" onClick={() => openEmail()} className={LINK}>
									{t("footer.email")}
								</button>
							</li>
						</ul>
					</nav>
				</div>
				<div className="mt-10 pt-5 border-t border-pp-rule flex flex-wrap items-center justify-between gap-x-6 gap-y-2 font-mono text-pp-label uppercase tracking-pp-label text-pp-muted">
					<p>
						© {new Date().getFullYear()} {INFO.main.name}
					</p>
					<a
						href="https://creative-forge.chloelavrat.com"
						target="_blank"
						rel="noopener noreferrer"
						className="hover:text-pp-ink transition-colors duration-150 inline-flex items-center min-h-11 sm:min-h-8"
					>
						→ {t("nav.creativeForge")}
					</a>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
